import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BodyTypes } from 'src/app/helpers';
import { RatingService } from 'src/app/services/rating/rating.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { UserService } from 'src/app/services/user-service/user.service';

@Component({
  selector: 'app-exterior',
  templateUrl: './exterior.component.html',
  styleUrls: ['./exterior.component.scss']
})
export class ExteriorComponent implements OnInit {
  public loaded: boolean = false;
  public vinInfo: Object = null;
  public vehicleBodyTypes: object = {
    bus: BodyTypes.bus,
    suv: BodyTypes.suv,
    sedan: BodyTypes.sedan,
    truckDouble: BodyTypes.truckDouble,
    truckSingle: BodyTypes.truckSingle,
    cargo: BodyTypes.cargo
  };
  public main: Object[] = [];

  constructor(
    public formBuilder: UntypedFormBuilder,
    public modalService: BsModalService,
    public sharedService: SharedService,
    public ratingService: RatingService,
    public userService: UserService
  ) {
    this.sharedService.setTile = 'exterior';

    console.log("4351354");
    
  }

  ngOnInit(): void {
    this.sharedService.vinInformation.subscribe((res) => {
      if (res) {
        this.vinInfo = res;
      }
    });
    this.mainParts('Exterior');
  }

  // getVehicleData() {
  //   const vehicle_id = { vehicle_id: this.sharedService.getVehicleId };
  //   this.userService.GetVinInfo(vehicle_id).subscribe(
  //     (res) => {
  //       let success = res['success'];
  //       let data = res['data'];

  //       if (success && Object.keys(data).length) {
  //         // let vehicleDetails: Object = data['vehicle_details'];
  //         let vehicleInformation: Object = data['vehicle_information'];

  //         this.vinInfo = vehicleInformation;
  //

  //         setTimeout(() => {
  //           this.mainParts('Exterior');
  //         }, 0);
  //       }
  //     },
  //     (error) => {
  //
  //     }
  //   );
  // }

  mainParts(type: string) {
    let data: MainParts = {
      body_type_id: this.vinInfo['body_type_id'].id,
      parts_condition_type: type,
      parent_id: null,
      vehicle_id: this.sharedService.getVehicleId
    };

    this.loaded = true;
    this.ratingService.getPartsCondition(data).subscribe(
      (res) => {
        let success: boolean = res['success'];
        let data: Object = res['data'];

        if (success) {
          this.loaded = false;
          this.main = data['ratings'];
        }
      },
      (error) => {
        this.loaded = false;
      }
    );
  }
}

interface MainParts {
  body_type_id: string;
  parts_condition_type: string;
  parent_id?: string;
  vehicle_id?: string;
}
